import { TransportRequestState, TransportRequestStatus } from '@stadtlandnetz/core'
import { transportRequestStateMapping } from '../stores/data.stores'
import { get } from 'svelte/store'

export function stateMappingIncludesStatus(status: string, transportRequestState: TransportRequestState): boolean {
    const stateMapping: Record<TransportRequestState, TransportRequestStatus[]> = get(transportRequestStateMapping)
    return stateMapping[transportRequestState].some((mapping) => mapping.system.value === status)
}
